var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},_vm._l((_vm.videoList),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',{staticClass:"video_con"},[_c('video',{staticClass:"video",attrs:{"src":_vm.baseImgUrl + item.img,"controls":""}})]),_c('div',{staticClass:"video_tit"},[_vm._v(_vm._s(item.titEn))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }